import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { propComparator } from '@fi-shared/utils/array-sort-comparators';
import { isDefined } from '@fi-shared/utils/is-defined';
import { isString } from '@fi-shared/utils/is-string';

export class WidgetPlaceHolderModel {
    Id: number;
    WidgetAdministrateId: number;
    Properties: any;
    ControlCollection: WidgetPlaceHolderControlModel[];

    constructor(data?) {
        if (!isDefined(data)) {
            data = {};
        }

        this.Id = data.Id;
        this.WidgetAdministrateId = data.WidgetAdministrateId;
        this.Properties =
            isString(data.Properties) && data.Properties.length > 0
                ? JSON.parse(data.Properties)
                : data.Properties || {};

        this.ControlCollection = [];
        if (data.ControlCollection) {
            data.ControlCollection.forEach((ControlData) => {
                this.ControlCollection.push(new WidgetPlaceHolderControlModel(ControlData));
            });

            this.ControlCollection = this.ControlCollection.sort(propComparator('SortOrder'));
        }
    }
}
